import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

export default function DailogUi({ 
    state, 
    setState, 
    handleClick,
    // Support new prop pattern
    open,
    setOpen,
    title,
    description,
    onConfirm,
    loading = false
}) {
    // Support both old and new prop patterns
    const isOpen = open !== undefined ? open : state;
    const handleSetOpen = setOpen || setState;
    const dialogTitle = title || "Deleting question & answer ?";
    const dialogDescription = description || "I am sure, you know what you are doing ?";
    const handleConfirm = onConfirm || handleClick;

    // functions------>
    const handleClose = () => {
        if (typeof handleSetOpen === 'function') {
            handleSetOpen(false);
        }
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} >
            <DialogTitle>
                {dialogTitle}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {dialogDescription}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus disabled={loading}>
                    Cancel
                </Button>
                <Button 
                    onClick={handleConfirm} 
                    color="error" 
                    variant="contained"
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                >
                    {loading ? "Deleting..." : "Confirm"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
